"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.statusInfo.images': 'immagini',
};
